import PartnersItem from "./PartnersItem";

export default PartnersItem;
